<template>
  <div class="hbox-container" :class="params.className" :style="{padding:params.padding}" ref="ct">
    <div class="handler"></div>
    <div class="hbox-column dragula-container" ref="columns"
         :class="{'fit-height':!params.dynamicHeight}"
         v-for="(col,index) in params.columns" :key="index">

    </div>
  </div>
</template>
<script>
  export default {
    name:"hbox-designer",
    props:{
      params:Object
    },
    data(){
      return {}
    },
    mounted() {
      let me=this;
      me.params.columns.forEach((col,index)=>{
        if(col.items){
          // let el=$(me.$el).find(">.hbox-column").eq(index)[0];
          let el=me.$refs.columns[index];
          me.$emit("addItems",col.items,el)
        }
      });
    },
    methods:{
      setContainerData(ct,items,data){
        let index=$(ct).index()-1;
        data.columns[index].items=items;
      }
    },
    watch:{
      "params.style":{
        immediate: true,
        handler(v){
          this.$nextTick(()=>{
            $(this.$refs.ct).attr("style",`${v} ; padding:${this.params.padding}`)
          })
        }
      },
      "params.columns":{
        deep:true,
        immediate: true,
        handler:function(newValue){
          this.$nextTick(() => {
            newValue.forEach((col, index) => {
              let div=this.$refs.columns[index];
              let style=`${(col.style || "")} ; width:${col.width};padding-left:${(col.paddingLeft || 0)};padding-right:${(col.paddingRight || 0)}`;
              $(div).attr("style",style);
            });
          });
        }
      }
    }
  }
</script>
<style scoped>
  .hbox-container{
    height:calc(100% - 4px);
  }
.dragula-container{
  display: inline-block;
  border: solid 1px #aaa;
  min-height:100px;
  overflow:auto;
  min-width:30px;
}
.fit-height{
  height:calc(100% - 15px);
}
.handler{
  cursor:move;
  background-color:#9e9e9e;
  height:15px;
  border:1px solid #aaa;
}

  .designer-active>.handler{
    background-color:#607D8B
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/hbox-designer.vue